"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const expertAvatarUpload_1 = __importDefault(require("../../../../../../../shared/components/avatarApload/expertAvatarUpload"));
const omit_1 = __importDefault(require("lodash/omit"));
require("./baseInfo.scss");
const editProps = [
    {
        name: "Full Name",
        key: "name",
        multiline: false,
    },
    {
        name: "Company",
        key: "company_name",
        multiline: false,
    },
    (expert) => {
        return expert.type === 1 ? {
            name: "Service Type",
            key: "mainService.name",
            editKey: "mainService",
            multiline: false,
            autocomplete: true,
            dataKey: "services"
        } : {
            name: "Occupation",
            key: "blocks.occupation",
            multiline: false
        };
    }
];
const BasicInfo = (props) => {
    const { expert } = props;
    const onEdit = (e, key) => {
        const val = e.target.value;
        props.editExpert({ key, val });
    };
    /*const [age, setAge] = React.useState('Occupation');

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setAge(event.target.value as string);
    };*/
    return expert ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks v2-baseInfo', square: true },
        react_1.default.createElement("h5", null, "Basic Information"),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 3 },
                react_1.default.createElement(expertAvatarUpload_1.default, null)),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 9, className: 'info' }, editProps.map((data, key) => {
                const val = typeof data === 'function' ? data(expert) : data;
                if (val.autocomplete) {
                    const list = get_1.default(props, val.dataKey);
                    const selected = list.find(l => l.name === get_1.default(expert, val.key));
                    return (list && list.length) ? (react_1.default.createElement(core_1.FormControl, { variant: "outlined", key: key, className: "occupation" },
                        react_1.default.createElement(core_1.InputLabel, { id: "select-service" }, "Service Type"),
                        react_1.default.createElement(core_1.Select, { labelId: "select-service", id: "select-service-outlined", defaultValue: selected === null || selected === void 0 ? void 0 : selected.name, onChange: (e, v) => {
                                const selected = list.find(l => l.name === e.target.value);
                                props.editExpert({ key: 'mainService', val: selected });
                            }, label: "Service Type" },
                            react_1.default.createElement(core_1.MenuItem, { value: "" },
                                react_1.default.createElement("em", null, "None")),
                            list.map((val, key) => (react_1.default.createElement(core_1.MenuItem, { key: key, value: val.name }, val.name)))))) : null;
                }
                if (expert.is_company && val.key === 'name')
                    return;
                return (react_1.default.createElement(core_1.TextField, { variant: "outlined", key: key, onChange: (e) => onEdit(e, val.key), margin: "dense", id: val.key, multiline: val.multiline, label: val.name, type: "text", defaultValue: get_1.default(expert, val.key), fullWidth: true }));
            }))))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert || experts.expert,
        services: experts.services.map((s) => omit_1.default(s, ['subCategories']))
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(BasicInfo);
